import { ReportToken } from 'core/slices/models';
import { MINUTES_BEFORE_EXPIRATION } from './TokenService';
import { HTTP_CODES } from 'core/utils';
import { request } from './ApiService';

const ENDPOINTS = {
  GET_TOKEN: '/api/v1/projects/:project_key/reports/:id/token',
};

const tokenCache: Map<string, ReportToken> = new Map<string, ReportToken>();

const getTokenFor = async (
  projectKey: string,
  reportId: string
): Promise<ReportToken> => {
  const cachedToken = tokenCache.get(reportId);
  if (cachedToken && validateCachedToken(cachedToken)) {
    return Promise.resolve(cachedToken);
  }

  const reportTokenEndpoint = ENDPOINTS.GET_TOKEN.replace(
    ':project_key',
    projectKey
  ).replace(':id', reportId);
  return request(reportTokenEndpoint, null, { method: 'POST' })
    .then(response => {
      if (response.status !== HTTP_CODES.OK) {
        return Promise.reject(response);
      } else {
        return response.json();
      }
    })
    .then((reportToken: ReportToken) => {
      tokenCache.set(reportId, reportToken);
      return reportToken;
    });
};

const validateTokenReportPair = (reportId: string, token: string): boolean => {
  return tokenCache.get(reportId)?.token === token;
};

const isAboutToExpire = (token: ReportToken): boolean => {
  // // Get the current time
  const currentTime = Date.now();
  const expiration = Date.parse(token.expiration);

  // Time until token expiration in milliseconds
  const timeUntilExpiration = expiration - currentTime;
  const timeToUpdate = MINUTES_BEFORE_EXPIRATION * 60 * 1000;

  return timeUntilExpiration <= timeToUpdate;
};

const validateCachedToken = (token: ReportToken): boolean => {
  if (!token.token || !token.expiration) {
    return false;
  }

  if (isAboutToExpire(token)) {
    return false;
  }

  return true;
};

export const BackendTokenService = {
  getTokenFor,
  validateTokenReportPair,
  isAboutToExpire,
};
